<div class="min-h-screen bg-gray-100 flex items-center justify-center p-4">
  <div class="form-container w-full max-w-4xl">
    <h1 class="text-3xl font-extrabold text-gray-800 text-center mb-8">Solicitud de Crédito</h1>
    <!-- hasta aca bien -->
     
    <div class="flex border-b border-gray-200 mb-6">
      <ng-container *ngFor="let tab of tabs; let i = index">
        <button
          class="flex-1 py-3 px-4 text-center text-sm font-medium border-b-2 transition-colors duration-200 ease-in-out
                 {{ currentTabIndex === i ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-600 hover:text-gray-800 hover:border-gray-300' }}"
          [class.cursor-not-allowed]="i > 0 && !currentFormGroup.valid && i > currentTabIndex"
          [disabled]="i > 0 && currentTabIndex < i && !currentFormGroup.valid"
          (click)="goToTab(i)">
          <span class="text-lg">{{tab.icon}}</span>
          <span class="hidden sm:inline">{{tab.label}}</span>
        </button>
      </ng-container>
    </div>

    <form class="space-y-6">
      <div *ngIf="currentTabIndex === 0" [formGroup]="personalDataFormGroup" class="fade-in">
        <h2 class="text-2xl font-bold text-gray-700 mb-6 text-center">Datos Personales</h2>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div class="form-group">
            <label for="firstName" class="form-label">Nombres</label>
            <input id="firstName" type="text" formControlName="firstName" class="form-input" placeholder="Ingresa tus nombres">
            <p *ngIf="personalDataFormGroup.controls['firstName'].invalid && personalDataFormGroup.controls['firstName'].touched" class="form-error">
              El nombre es requerido.
            </p>
          </div>

          <div class="form-group">
            <label for="lastName" class="form-label">Apellidos</label>
            <input id="lastName" type="text" formControlName="lastName" class="form-input" placeholder="Ingresa tus apellidos">
            <p *ngIf="personalDataFormGroup.controls['lastName'].invalid && personalDataFormGroup.controls['lastName'].touched" class="form-error">
              El apellido es requerido.
            </p>
          </div>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div class="form-group">
            <label for="documentType" class="form-label">Tipo de Documento</label>
            <select id="documentType" formControlName="documentType" class="form-select">
              <option value="cedula">Cédula de Ciudadanía</option>
              <option value="passport">Pasaporte</option>
              <option value="foreign_id">Cédula de Extranjería</option>
            </select>
            <p *ngIf="personalDataFormGroup.controls['documentType'].invalid && personalDataFormGroup.controls['documentType'].touched" class="form-error">
              El tipo de documento es requerido.
            </p>
          </div>

          <div class="form-group">
            <label for="documentNumber" class="form-label">Número de Documento</label>
            <input id="documentNumber" type="text" formControlName="documentNumber" class="form-input" placeholder="Número de documento">
            <p *ngIf="personalDataFormGroup.controls['documentNumber'].invalid && personalDataFormGroup.controls['documentNumber'].touched" class="form-error">
              El número de documento es requerido.
            </p>
          </div>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div class="form-group">
            <label for="birthDate" class="form-label">Fecha de Nacimiento</label>
            <input id="birthDate" type="date" formControlName="birthDate" class="form-input">
            <p *ngIf="personalDataFormGroup.controls['birthDate'].invalid && personalDataFormGroup.controls['birthDate'].touched" class="form-error">
              La fecha de nacimiento es requerida.
            </p>
          </div>

          <div class="form-group">
            <label for="email" class="form-label">Email</label>
            <input id="email" type="email" formControlName="email" class="form-input" placeholder="tu@email.com">
            <p *ngIf="personalDataFormGroup.controls['email'].hasError('required') && personalDataFormGroup.controls['email'].touched" class="form-error">
              El email es requerido.
            </p>
            <p *ngIf="personalDataFormGroup.controls['email'].hasError('email') && personalDataFormGroup.controls['email'].touched" class="form-error">
              Formato de email inválido.
            </p>
          </div>

          <div class="form-group">
            <label for="phone" class="form-label">Teléfono</label>
            <input id="phone" type="tel" formControlName="phone" class="form-input" placeholder="+57 3XX XXX XXXX">
            <p *ngIf="personalDataFormGroup.controls['phone'].invalid && personalDataFormGroup.controls['phone'].touched" class="form-error">
              El teléfono es requerido.
            </p>
          </div>
        </div>
      </div>

      <div *ngIf="currentTabIndex === 1" [formGroup]="employmentDataFormGroup" class="fade-in">
        <h2 class="text-2xl font-bold text-gray-700 mb-6 text-center">Información Laboral</h2>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div class="form-group">
            <label for="companyName" class="form-label">Nombre de la Empresa</label>
            <input id="companyName" type="text" formControlName="companyName" class="form-input">
            <p *ngIf="employmentDataFormGroup.controls['companyName'].invalid && employmentDataFormGroup.controls['companyName'].touched" class="form-error">
              El nombre de la empresa es requerido.
            </p>
          </div>

          <div class="form-group">
            <label for="position" class="form-label">Cargo</label>
            <input id="position" type="text" formControlName="position" class="form-input">
            <p *ngIf="employmentDataFormGroup.controls['position'].invalid && employmentDataFormGroup.controls['position'].touched" class="form-error">
              El cargo es requerido.
            </p>
          </div>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div class="form-group">
            <label for="seniority" class="form-label">Antigüedad (años)</label>
            <input id="seniority" type="number" formControlName="seniority" class="form-input">
            <p *ngIf="employmentDataFormGroup.controls['seniority'].hasError('required') && employmentDataFormGroup.controls['seniority'].touched" class="form-error">
              La antigüedad es requerida.
            </p>
            <p *ngIf="employmentDataFormGroup.controls['seniority'].hasError('min') && employmentDataFormGroup.controls['seniority'].touched" class="form-error">
              La antigüedad debe ser un número positivo.
            </p>
          </div>

          <div class="form-group">
            <label for="monthlySalary" class="form-label">Salario Mensual</label>
            <input id="monthlySalary" type="number" formControlName="monthlySalary" class="form-input">
            <p *ngIf="employmentDataFormGroup.controls['monthlySalary'].hasError('required') && employmentDataFormGroup.controls['monthlySalary'].touched" class="form-error">
              El salario es requerido.
            </p>
            <p *ngIf="employmentDataFormGroup.controls['monthlySalary'].hasError('min') && employmentDataFormGroup.controls['monthlySalary'].touched" class="form-error">
              El salario debe ser un número positivo.
            </p>
          </div>
        </div>
      </div>

      <div *ngIf="currentTabIndex === 2" [formGroup]="financialDataFormGroup" class="fade-in">
        <h2 class="text-2xl font-bold text-gray-700 mb-6 text-center">Información Financiera</h2>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div class="form-group">
            <label for="additionalIncome" class="form-label">Ingresos Adicionales (opcional)</label>
            <input id="additionalIncome" type="number" formControlName="additionalIncome" class="form-input">
            <p *ngIf="financialDataFormGroup.controls['additionalIncome'].hasError('min') && financialDataFormGroup.controls['additionalIncome'].touched" class="form-error">
              Debe ser un número positivo.
            </p>
          </div>

          <div class="form-group">
            <label for="monthlyExpenses" class="form-label">Gastos Mensuales</label>
            <input id="monthlyExpenses" type="number" formControlName="monthlyExpenses" class="form-input">
            <p *ngIf="financialDataFormGroup.controls['monthlyExpenses'].hasError('required') && financialDataFormGroup.controls['monthlyExpenses'].touched" class="form-error">
              Los gastos mensuales son requeridos.
            </p>
            <p *ngIf="financialDataFormGroup.controls['monthlyExpenses'].hasError('min') && financialDataFormGroup.controls['monthlyExpenses'].touched" class="form-error">
              Debe ser un número positivo.
            </p>
          </div>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div class="form-group">
            <label for="creditAmountRequested" class="form-label">Valor Solicitado del Crédito</label>
            <input id="creditAmountRequested" type="number" formControlName="creditAmountRequested" class="form-input">
            <p *ngIf="financialDataFormGroup.controls['creditAmountRequested'].hasError('required') && financialDataFormGroup.controls['creditAmountRequested'].touched" class="form-error">
              El valor del crédito es requerido.
            </p>
            <p *ngIf="financialDataFormGroup.controls['creditAmountRequested'].hasError('min') && financialDataFormGroup.controls['creditAmountRequested'].touched" class="form-error">
              Debe ser un número positivo.
            </p>
          </div>

          <div class="form-group">
            <label for="termMonths" class="form-label">Plazo (meses)</label>
            <input id="termMonths" type="number" formControlName="termMonths" class="form-input">
            <p *ngIf="financialDataFormGroup.controls['termMonths'].hasError('required') && financialDataFormGroup.controls['termMonths'].touched" class="form-error">
              El plazo es requerido.
            </p>
            <p *ngIf="financialDataFormGroup.controls['termMonths'].hasError('min') && financialDataFormGroup.controls['termMonths'].touched" class="form-error">
              El plazo debe ser un número positivo.
            </p>
          </div>
        </div>
      </div>

      <div *ngIf="currentTabIndex === 3" [formGroup]="contactDataFormGroup" class="fade-in">
        <h2 class="text-2xl font-bold text-gray-700 mb-6 text-center">Información de Contacto</h2>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div class="form-group">
            <label for="address" class="form-label">Dirección de Residencia</label>
            <input id="address" type="text" formControlName="address" class="form-input">
            <p *ngIf="contactDataFormGroup.controls['address'].invalid && contactDataFormGroup.controls['address'].touched" class="form-error">
              La dirección es requerida.
            </p>
          </div>

          <div class="form-group">
            <label for="city" class="form-label">Ciudad</label>
            <input id="city" type="text" formControlName="city" class="form-input">
            <p *ngIf="contactDataFormGroup.controls['city'].invalid && contactDataFormGroup.controls['city'].touched" class="form-error">
              La ciudad es requerida.
            </p>
          </div>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div class="form-group">
            <label for="country" class="form-label">País</label>
            <input id="country" type="text" formControlName="country" class="form-input">
            <p *ngIf="contactDataFormGroup.controls['country'].invalid && contactDataFormGroup.controls['country'].touched" class="form-error">
              El país es requerido.
            </p>
          </div>

          <div class="form-group">
            <label for="personalReference1Name" class="form-label">Nombre de Referencia Personal 1</label>
            <input id="personalReference1Name" type="text" formControlName="personalReference1Name" class="form-input">
            <p *ngIf="contactDataFormGroup.controls['personalReference1Name'].invalid && contactDataFormGroup.controls['personalReference1Name'].touched" class="form-error">
              El nombre de la referencia personal es requerido.
            </p>
          </div>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div class="form-group">
            <label for="personalReference1Phone" class="form-label">Teléfono de Referencia Personal 1</label>
            <input id="personalReference1Phone" type="tel" formControlName="personalReference1Phone" class="form-input">
            <p *ngIf="contactDataFormGroup.controls['personalReference1Phone'].invalid && contactDataFormGroup.controls['personalReference1Phone'].touched" class="form-error">
              El teléfono de la referencia personal es requerido.
            </p>
          </div>

          <div class="form-group">
            <label for="personalReference2Name" class="form-label">Nombre de Referencia Personal 2 (Opcional)</label>
            <input id="personalReference2Name" type="text" formControlName="personalReference2Name" class="form-input">
          </div>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div class="form-group">
            <label for="personalReference2Phone" class="form-label">Teléfono de Referencia Personal 2 (Opcional)</label>
            <input id="personalReference2Phone" type="tel" formControlName="personalReference2Phone" class="form-input">
          </div>
        </div>
      </div>

      <div *ngIf="currentTabIndex === 4" [formGroup]="referencialDataFormGroup" class="fade-in">
        <h2 class="text-2xl font-bold text-gray-700 mb-6 text-center">Información de Contacto</h2>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div class="form-group">
            <label for="address" class="form-label">Dirección de Residencia</label>
            <input id="address" type="text" formControlName="address" class="form-input">
            <p *ngIf="contactDataFormGroup.controls['address'].invalid && contactDataFormGroup.controls['address'].touched" class="form-error">
              La dirección es requerida.
            </p>
          </div>

          <div class="form-group">
            <label for="city" class="form-label">Ciudad</label>
            <input id="city" type="text" formControlName="city" class="form-input">
            <p *ngIf="contactDataFormGroup.controls['city'].invalid && contactDataFormGroup.controls['city'].touched" class="form-error">
              La ciudad es requerida.
            </p>
          </div>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div class="form-group">
            <label for="country" class="form-label">País</label>
            <input id="country" type="text" formControlName="country" class="form-input">
            <p *ngIf="contactDataFormGroup.controls['country'].invalid && contactDataFormGroup.controls['country'].touched" class="form-error">
              El país es requerido.
            </p>
          </div>

          <div class="form-group">
            <label for="personalReference1Name" class="form-label">Nombre de Referencia Personal 1</label>
            <input id="personalReference1Name" type="text" formControlName="personalReference1Name" class="form-input">
            <p *ngIf="contactDataFormGroup.controls['personalReference1Name'].invalid && contactDataFormGroup.controls['personalReference1Name'].touched" class="form-error">
              El nombre de la referencia personal es requerido.
            </p>
          </div>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div class="form-group">
            <label for="personalReference1Phone" class="form-label">Teléfono de Referencia Personal 1</label>
            <input id="personalReference1Phone" type="tel" formControlName="personalReference1Phone" class="form-input">
            <p *ngIf="contactDataFormGroup.controls['personalReference1Phone'].invalid && contactDataFormGroup.controls['personalReference1Phone'].touched" class="form-error">
              El teléfono de la referencia personal es requerido.
            </p>
          </div>

          <div class="form-group">
            <label for="personalReference2Name" class="form-label">Nombre de Referencia Personal 2 (Opcional)</label>
            <input id="personalReference2Name" type="text" formControlName="personalReference2Name" class="form-input">
          </div>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div class="form-group">
            <label for="personalReference2Phone" class="form-label">Teléfono de Referencia Personal 2 (Opcional)</label>
            <input id="personalReference2Phone" type="tel" formControlName="personalReference2Phone" class="form-input">
          </div>
        </div>
      </div>

      <div *ngIf="currentTabIndex === 5" [formGroup]="paymnetDataFormGroup" class="fade-in">
        <h2 class="text-2xl font-bold text-gray-700 mb-6 text-center">Información de Contacto</h2>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div class="form-group">
            <label for="address" class="form-label">Dirección de Residencia</label>
            <input id="address" type="text" formControlName="address" class="form-input">
            <p *ngIf="contactDataFormGroup.controls['address'].invalid && contactDataFormGroup.controls['address'].touched" class="form-error">
              La dirección es requerida.
            </p>
          </div>

          <div class="form-group">
            <label for="city" class="form-label">Ciudad</label>
            <input id="city" type="text" formControlName="city" class="form-input">
            <p *ngIf="contactDataFormGroup.controls['city'].invalid && contactDataFormGroup.controls['city'].touched" class="form-error">
              La ciudad es requerida.
            </p>
          </div>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div class="form-group">
            <label for="country" class="form-label">País</label>
            <input id="country" type="text" formControlName="country" class="form-input">
            <p *ngIf="contactDataFormGroup.controls['country'].invalid && contactDataFormGroup.controls['country'].touched" class="form-error">
              El país es requerido.
            </p>
          </div>

          <div class="form-group">
            <label for="personalReference1Name" class="form-label">Nombre de Referencia Personal 1</label>
            <input id="personalReference1Name" type="text" formControlName="personalReference1Name" class="form-input">
            <p *ngIf="contactDataFormGroup.controls['personalReference1Name'].invalid && contactDataFormGroup.controls['personalReference1Name'].touched" class="form-error">
              El nombre de la referencia personal es requerido.
            </p>
          </div>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div class="form-group">
            <label for="personalReference1Phone" class="form-label">Teléfono de Referencia Personal 1</label>
            <input id="personalReference1Phone" type="tel" formControlName="personalReference1Phone" class="form-input">
            <p *ngIf="contactDataFormGroup.controls['personalReference1Phone'].invalid && contactDataFormGroup.controls['personalReference1Phone'].touched" class="form-error">
              El teléfono de la referencia personal es requerido.
            </p>
          </div>

          <div class="form-group">
            <label for="personalReference2Name" class="form-label">Nombre de Referencia Personal 2 (Opcional)</label>
            <input id="personalReference2Name" type="text" formControlName="personalReference2Name" class="form-input">
          </div>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div class="form-group">
            <label for="personalReference2Phone" class="form-label">Teléfono de Referencia Personal 2 (Opcional)</label>
            <input id="personalReference2Phone" type="tel" formControlName="personalReference2Phone" class="form-input">
          </div>
        </div>
      </div>

      <div class="flex justify-between mt-8">
        <button
          type="button"
          (click)="previousTab()"
          [disabled]="currentTabIndex === 0"
          class="btn-secondary">
          Anterior
        </button>

        <button
          type="button"
          (click)="nextTab()"
          *ngIf="currentTabIndex < tabs.length - 1"
          [disabled]="!currentFormGroup.valid"
          class="btn-primary">
          Siguiente
        </button>

        <button
          type="button"
          (click)="submitForm()"
          *ngIf="currentTabIndex === tabs.length - 1"
          [disabled]="!personalDataFormGroup.valid || !employmentDataFormGroup.valid || !financialDataFormGroup.valid || !contactDataFormGroup.valid"
          class="btn-primary">
          Enviar Solicitud
        </button>
      </div>
    </form>
  </div>
</div>